var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptydata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 114,
    viewBox: "0 0 152 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.17 0.5H32.8081C28.6954 0.5 25.3613 4.01776 25.3613 8.35714V102.643C25.3613 106.982 28.6954 110.5 32.8081 110.5H122.17C126.283 110.5 129.617 106.982 129.617 102.643V8.35714C129.617 4.01776 126.283 0.5 122.17 0.5Z",
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2146_809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7449 42.9265H142.277C143.264 42.9265 144.211 43.3404 144.91 44.0772C145.608 44.8139 146 45.8132 146 46.8551V66.4979C146 67.5399 145.608 68.5391 144.91 69.2759C144.211 70.0126 143.264 70.4265 142.277 70.4265H41.7449C40.7574 70.4265 39.8103 70.0126 39.112 69.2759C38.4138 68.5391 38.0215 67.5399 38.0215 66.4979V46.8551C38.0215 45.8132 38.4138 44.8139 39.112 44.0772C39.8103 43.3404 40.7574 42.9265 41.7449 42.9265Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8516 49.214H77.4899C76.2561 49.214 75.2559 50.2693 75.2559 51.5711C75.2559 52.8729 76.2561 53.9283 77.4899 53.9283H96.8516C98.0854 53.9283 99.0856 52.8729 99.0856 51.5711C99.0856 50.2693 98.0854 49.214 96.8516 49.214Z",
    fill: "#C6CFD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.256 59.4276H77.4899C76.2561 59.4276 75.2559 60.4829 75.2559 61.7848C75.2559 63.0866 76.2561 64.1419 77.4899 64.1419H110.256C111.49 64.1419 112.49 63.0866 112.49 61.7848C112.49 60.4829 111.49 59.4276 110.256 59.4276Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7346 64.1459C64.6417 64.1459 67.8091 60.804 67.8091 56.6816C67.8091 52.5592 64.6417 49.2173 60.7346 49.2173C56.8275 49.2173 53.6602 52.5592 53.6602 56.6816C53.6602 60.804 56.8275 64.1459 60.7346 64.1459Z",
    fill: "#D9D9D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2146_809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7234 76.7178H110.255C111.243 76.7178 112.19 77.1317 112.888 77.8684C113.586 78.6052 113.979 79.6044 113.979 80.6463V100.289C113.979 101.331 113.586 102.33 112.888 103.067C112.19 103.804 111.243 104.218 110.255 104.218H9.7234C8.7359 104.218 7.78883 103.804 7.09056 103.067C6.39229 102.33 6 101.331 6 100.289V80.6463C6 79.6044 6.39229 78.6052 7.09056 77.8684C7.78883 77.1317 8.7359 76.7178 9.7234 76.7178V76.7178Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8291 83.001H45.4674C44.2336 83.001 43.2334 84.0563 43.2334 85.3581C43.2334 86.6599 44.2336 87.7153 45.4674 87.7153H64.8291C66.063 87.7153 67.0632 86.6599 67.0632 85.3581C67.0632 84.0563 66.063 83.001 64.8291 83.001Z",
    fill: "#C6CFD2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2334 93.2146H45.4674C44.2336 93.2146 43.2334 94.2699 43.2334 95.5717C43.2334 96.8736 44.2336 97.9289 45.4674 97.9289H78.2334C79.4672 97.9289 80.4674 96.8736 80.4674 95.5717C80.4674 94.2699 79.4672 93.2146 78.2334 93.2146Z",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0335 97.9295C22.9406 97.9295 26.1079 94.5877 26.1079 90.4653C26.1079 86.3429 22.9406 83.001 19.0335 83.001C15.1263 83.001 11.959 86.3429 11.959 90.4653C11.959 94.5877 15.1263 97.9295 19.0335 97.9295Z",
    fill: "#D9D9D9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2146_809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.255 9.14429H9.7234C7.66702 9.14429 6 10.9032 6 13.0729V32.7157C6 34.8854 7.66702 36.6443 9.7234 36.6443H110.255C112.312 36.6443 113.979 34.8854 113.979 32.7157V13.0729C113.979 10.9032 112.312 9.14429 110.255 9.14429Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3399 15.4275H43.9782C42.7444 15.4275 41.7441 16.4828 41.7441 17.7846C41.7441 19.0864 42.7444 20.1418 43.9782 20.1418H63.3399C64.5737 20.1418 65.5739 19.0864 65.5739 17.7846C65.5739 16.4828 64.5737 15.4275 63.3399 15.4275Z",
    fill: "#C6CFD2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7441 25.6411H43.9782C42.7444 25.6411 41.7441 26.6964 41.7441 27.9983C41.7441 29.3001 42.7444 30.3554 43.9782 30.3554H76.7441C77.978 30.3554 78.9782 29.3001 78.9782 27.9983C78.9782 26.6964 77.978 25.6411 76.7441 25.6411Z",
    fill: "#F7F7F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7122 30.3557C32.6193 30.3557 35.7866 27.0138 35.7866 22.8914C35.7866 18.769 32.6193 15.4271 28.7122 15.4271C24.805 15.4271 21.6377 18.769 21.6377 22.8914C21.6377 27.0138 24.805 30.3557 28.7122 30.3557Z",
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2146_809",
    x: 32.0215,
    y: 39.9265,
    width: 119.979,
    height: 39.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2146_809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2146_809",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2146_809",
    x: 0,
    y: 73.7178,
    width: 119.979,
    height: 39.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2146_809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2146_809",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2146_809",
    x: 0,
    y: 6.14429,
    width: 119.979,
    height: 39.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2146_809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2146_809",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptydata);
export default __webpack_public_path__ + "static/media/emptydata.9544e37339ce4ee4659c1941be13374e.svg";
export { ForwardRef as ReactComponent };